// extracted by mini-css-extract-plugin
export default {"root":"RefiByYearsInHome_root__Tp6+i","heading":"RefiByYearsInHome_heading__D3qix"};